import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'

export const internalTransferDetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$internalTransferId`,
    component: lazyRouteComponent(() => import('./Details'))
  })
